var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.iconName
    ? _c(
        "div",
        {
          staticClass:
            "icon-details-svg-dl display-inline-flex flex-items-center",
          staticStyle: {
            "--button-margin-bottom": "0",
            "--button-background": "transparent",
            "--button-hover-background": "transparent",
            "--button-hover-color": "var(--fa-dk-blue)",
            "--button-active-color": "var(--fa-dk-blue)",
            "--margin-bottom": "0",
            "--padding-left": "0",
            gap: "var(--spacing-4xs)",
          },
        },
        [
          _c("div", { staticStyle: { "--margin-bottom": "0" } }, [
            _c(
              "button",
              {
                staticClass:
                  "icon-action-download-svg flat compact display-inline-block padding-x-2xs",
                staticStyle: { "--button-color": "var(--fa-navy)" },
                attrs: {
                  type: "button",
                  "aria-label": "Download SVG File",
                  "data-balloon-pos": "up",
                  disabled: _vm.downloadStarted,
                },
                on: { click: _vm.downloadSVG },
              },
              [
                _c("font-awesome-icon", {
                  attrs: {
                    icon: _vm.$v6.solid.faArrowToBottom,
                    "fixed-width": "",
                    size: "lg",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v("Download SVG file"),
                ]),
              ],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }